import React, { useEffect, useState } from "react";
import { api, money, shortDate } from "../lib/api";
import PageHeader from "../components/PageHeader";
import { KpiCard, StatusPill } from "../components/UI";

export default function Transport() {
  const [moves, setMoves] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => { api.get("/transport").then(r => setMoves(r.data.moves)); }, []);

  const outCount = moves.filter(m => m.kind === "out").length;
  const inCount = moves.filter(m => m.kind === "in").length;
  const transportRevenue = moves.reduce((s, m) => s + (m.charge || 0), 0);
  const filtered = moves.filter(m => {
    if (!q) return true;
    const s = q.toLowerCase();
    return (
      (m.unit_number||"").toLowerCase().includes(s) ||
      (m.model||"").toLowerCase().includes(s) ||
      (m.customer_name||"").toLowerCase().includes(s) ||
      (m.from_where||"").toLowerCase().includes(s) ||
      (m.to_where||"").toLowerCase().includes(s)
    );
  });

  return (
    <div data-testid="transport-page">
      <PageHeader
        title="Transport"
        subtitle="Every move in and out — with the transport charge next to it"
      />

      <div className="ach-kpi-row" style={{gridTemplateColumns:"repeat(3, minmax(0,1fr))"}}>
        <KpiCard tone="green" number={outCount} label="Moves out (to site)" testid="tr-kpi-out" />
        <KpiCard tone="neutral" number={inCount} label="Moves in (back to yard)" testid="tr-kpi-in" />
        <KpiCard tone="maroon" number={money(transportRevenue).replace(".00","")} label="Transport charged (billed as one-off)" testid="tr-kpi-revenue" />
      </div>

      <div className="ach-card">
        <div style={{display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:12}}>
          <h2 className="ach-card__title" style={{margin:0}}>Every move — newest first</h2>
          <input placeholder="Search unit, model, customer, site…" value={q} onChange={(e)=>setQ(e.target.value)}
            data-testid="transport-search"
            style={{border:"1px solid var(--ach-card-border)", borderRadius:6, padding:"8px 12px", fontSize:13, width: 280}} />
        </div>
        <div className="ach-table-wrap">
          <table className="ach-table">
            <thead>
              <tr>
                <th>Machine</th>
                <th>Direction</th>
                <th>From</th>
                <th>To</th>
                <th>Customer</th>
                <th>When</th>
                <th className="money">Charge</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((m, i) => (
                <tr key={i}>
                  <td><div className="unit-num">{m.unit_number}</div><div className="subtitle">{m.model}</div></td>
                  <td><StatusPill tone={m.kind === "out" ? "green" : "neutral"}>{m.kind === "out" ? "GOING OUT" : "COMING IN"}</StatusPill></td>
                  <td>{m.from_where}</td>
                  <td>{m.to_where}</td>
                  <td>{m.customer_name}</td>
                  <td>{shortDate(m.when)}</td>
                  <td className="money">{m.charge ? money(m.charge) : "—"}</td>
                </tr>
              ))}
              {filtered.length === 0 && (
                <tr><td colSpan={7} style={{textAlign:"center", padding: 24, color:"var(--ach-text-2)"}}>No moves match.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
